import { render, staticRenderFns } from "./gishuun_bus_bagts.vue?vue&type=template&id=dc251164&scoped=true&"
import script from "./gishuun_bus_bagts.vue?vue&type=script&lang=js&"
export * from "./gishuun_bus_bagts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc251164",
  null
  
)

export default component.exports